import styled from 'styled-components'
import { Spinner as ReactSpinner } from 'reactstrap'

import { COLOURS } from 'resources'

export const Container = styled.div`
  background-color: ${COLOURS.lightGrey6};
  border-radius: 4px;
  padding: 20px;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
`

export const Spinner = styled(ReactSpinner)`
  margin-right: 10px;
`

export const IconContainer = styled.div`
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  padding: 15px;
`

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`

export const Title = styled.span`
  color: ${COLOURS.neutralBlack};
  font-family: Druk, sans-serif;
  font-size: 30px;
  line-height: 30px;
  white-space: pre-wrap;
  margin: 0;
`

export const GreyTitle = styled(Title)`
  color: ${COLOURS.lightGrey4};
`

export const EditIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 15px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`

export const Description = styled.p`
  color: ${COLOURS.neutralBlack};
  font-family: 'EBGaramond', sans-serif;
  font-size: 12px;
  margin: 0;
  white-space: pre-wrap;
`
